"use client";

import { useRouter } from "next/navigation";

type LegalBackButtonProps = {
  fallbackHref?: string;
};

export default function LegalBackButton({ fallbackHref = "/" }: LegalBackButtonProps) {
  const router = useRouter();

  const handleBack = () => {
    if (window.history.length > 1) {
      router.back();
      return;
    }

    router.push(fallbackHref);
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      className="inline-flex items-center rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm transition hover:bg-slate-50"
    >
      Retour
    </button>
  );
}
